import React from "react";

const SucceedFailRatesWidget: React.FC = () => {
  return (
    <div className="widget">
      <h2 className="text-lg font-bold mb-2">Succeed FailRates</h2>
      <img
        src="/images/SucceedFailRatesWidget.png"
        alt="Succeed FailRates Chart"
        className="w-full h-auto"
      />
    </div>
  );
};

export default SucceedFailRatesWidget;
